var Theme;

jQuery(document).ready(function(){

	Theme = {

		/**
		 * Init
		 */
		init:function(){

			// Cache elements
			Theme.w = jQuery(window);
			Theme.windowWidth = Theme.w.width();
			Theme.html = jQuery('html');
			Theme.body = jQuery('body');

			Theme.toggleNavButton = jQuery('.toggle-nav');

			Theme.tabNav = jQuery('.tab-navigation');
			Theme.tabNavList = Theme.tabNav.find('ul');
			Theme.tabNavButton = Theme.tabNav.find('a');
			Theme.tabTitleButton = jQuery('.tab-title');

			Theme.slider = jQuery('.slider');
			Theme.sliderSubtitle = jQuery('.slider-subtitle');
			Theme.sliderTitle = jQuery('.slider-title');
			Theme.slides = Theme.slider.find('.slide');
			Theme.slideCount = Theme.slides.length;

			Theme.raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame;

			Theme.anchorButton = jQuery('.scroll-to');
			Theme.scrollTopButton = jQuery(".scroll-to-top")
			Theme.scrollPosition = Theme.w.scrollTop();

			Theme.teaserImages = jQuery('.component-teaser-image');

			Theme.divisionOption = jQuery('.division-option');
			Theme.divisions = jQuery('.component-staff-division-list');

			Theme.modalButton = jQuery('a[href*="/modals/"]');

			// Go!
			Theme.bindings();

		},

		bindings:function(){

			// Lightbox
			jQuery('.gallery a').filter('[href$=".jpg"],[href$=".jepg"],[href$=".png"]').attr('rel','gallery').fancybox({
				padding: 0
			});
			jQuery('a[href$=".jpg"],a[href$=".jepg"],a[href$=".png"]').not('[rel="gallery"]').fancybox({
				padding: 0
			});

			jQuery('.component-modal-button').fancybox({
				width: 1020,
				height: 645,
				autoSize: false,
				padding: 30,
			});

			Theme.modalButton.click(function(e){
				e.preventDefault();
				Theme.openModal(jQuery(this));
			});

			// Anchors
			Theme.anchorButton.click(function(e){
				e.preventDefault();

				var obj = jQuery(this);
					target = ( '#' == obj.attr('href') ) ? false : jQuery('#' + obj.attr('href'));
					pos = ( target.length ) ? target.offset().top : 0;

				jQuery('html,body').stop().animate({
					scrollTop:pos
				}, 1000);

			});

			// Slider
			if ( 1 < Theme.slideCount ) {

				var conf = {
					//auto: Theme.slider.data('auto') ? true : false,
					auto: false,
					mode: Theme.slider.data('mode') ? Theme.slider.data('mode') : 'horizontal',
					pause: Theme.slider.data('pause') ? Theme.slider.data('pause') : 4000,
					speed: Theme.slider.data('speed') ? Theme.slider.data('speed') : 500,
					randomStart: Theme.slider.data('random') ? true : false,
					video: Theme.slider.data('video') ? true : false,
					pager: !Theme.slider.data('pager') ? false : true,
					pagerType: Theme.slider.data('pagertype') ? Theme.slider.data('pagertype') : 'full',
					controls: !Theme.slider.data('controls') ? false : true,
					onSliderLoad:function(currentIndex){

						var index = ( 'fade' == Theme.slider.data('mode') ) ? currentIndex : currentIndex + 1,
							slide = Theme.slider.find('.slide:eq(' + index + ')'),
							slideVideo = slide.find('.slide-video');

						if ( slideVideo.data('video') ) {

							slideVideo.vide({
								mp4: slideVideo.data('mp4'),
								webm: slideVideo.data('webm'),
								ogv: slideVideo.data('ogv'),
								poster: slideVideo.data('poster'),
							},{
								posterType: 'jpg'
							});

							var video = slideVideo.find('video'),
								duration = slideVideo.data('length') * 1000;

							//Theme.slider.stopAuto();
							video.currentTime = 0;
							video.get(0).play();

							/*
							setTimeout(function(){
								Theme.slider.startAuto();
							}, duration);
							*/
						}

					},
					onSlideBefore:function(slide, oldIndex, newIndex){

						var slideVideo = slide.find('.slide-video');

						if ( slideVideo ) {
							slideVideo.vide({
								mp4: slideVideo.data('mp4'),
								webm: slideVideo.data('webm'),
								ogv: slideVideo.data('ogv'),
								poster: slideVideo.data('poster'),
							});
							slideVideo.removeAttr('data-video');
						}

						var video = slideVideo.find('video');

						if ( 1 == video.length ) {

							var duration = slideVideo.data('length') * 1000;

							//Theme.slider.stopAuto();
							video.currentTime = 0;
							video.get(0).play();

							/*
							setTimeout(function(){
								Theme.slider.startAuto();
							}, duration);
							*/

						}

						if ( slide.data('title') )
							Theme.sliderTitle.text( slide.data('title') );
						else
							Theme.sliderTitle.text('');

						if ( slide.data('subtitle') )
							Theme.sliderSubtitle.text( slide.data('subtitle') );
						else
							Theme.sliderSubtitle.text('');

					}
				}

				Theme.slider = Theme.slider.bxSlider(conf);

			}

			// Toggle nav
			Theme.toggleNavButton.click(function(e){
				e.preventDefault();
				Theme.toggleNav();
			});

			// Scroll to top
			Theme.scrollTopButton.click(function() {
				jQuery("html, body").animate({ scrollTop: 0 }, "slow");
				return false;
			});

			// Scroll actions
			Theme.scroll();

			// Resize action
			Theme.resize();

			// Tab nav
			Theme.tabNavButton.click(function(e){
				e.preventDefault();
				Theme.tabShow( jQuery(this) );
			});
			Theme.tabInit();

			// Tab title
			Theme.tabTitleButton.click(function(e){
				e.preventDefault();
				Theme.tabSlideToggle( jQuery(this) );
			});

			// Highperformance scroll event
			if ( 0 < Theme.tabNav.length) {
				Theme.w.scroll(function(){
					Theme.scrollPosition = Theme.w.scrollTop();
					Theme.scroll();
				});
		    }

			// Hover effect
			if ( 0 < Theme.teaserImages.length ) {

				Theme.teaserImages.each(function(){

					var container = jQuery(this).parent(),
						imagesCount = container.find('.component-teaser-image img').length;

					if ( 2 > imagesCount )
						return;

					var interval,
						current = 0;

					container.hover(function(){

						var index = ( container.data('index') ) ? container.data('index') : 0;

						interval = setInterval(function(){
							index = ( imagesCount == index + 1 ) ? 0 : index + 1;
							container.find('img:eq(' + index + ')').fadeIn('fast');
							container.find('img').not(':eq(' + index + ')').fadeOut('fast');
							container.data('index',index);
						}, 1000 )

					},function(){
						clearInterval(interval);
					});
				});

			}

			// Staff filter
			Theme.divisionOption.change(function(){
				var current = Theme.divisionOption.filter(':checked').val(),
					target = Theme.divisions.filter('#component-staff-division-list-' + current );

				if ( 'all' == current ) {
					Theme.divisions.show();
				} else {
					Theme.divisions.hide();
					target.show();
				}
			});

		},

		openModal:function( obj ){
			jQuery.fancybox({
				type: 'iframe',
				href: obj.attr('href'),
				width: 1080,
				height: 645,
				autoSize: false,
				padding: 30,
			});
		},

		resize:function(){
			if ( 0 < Theme.tabNav.length )
				Theme.tabNavPosition = (Theme.body.hasClass('admin-bar') ) ? Theme.tabNav.offset().top - jQuery('#wpadminbar').height() : Theme.tabNav.offset().top;
		},

		scroll:function(){

			if ( Theme.scrollPosition > Theme.tabNavPosition ) {
				Theme.body.addClass( 'sticky-tabnav' );
				Theme.tabNav.css({
					height: Theme.tabNavList.outerHeight()
				});
			} else {
				Theme.body.removeClass( 'sticky-tabnav' );
				Theme.tabNav.removeAttr('style');
			}

		},

		tabInit:function(){

			if ( '' == window.location.hash ) {
				jQuery('.tab').not(':first').hide()
			} else {
				Theme.tabNavButton.filter('[data-title="' + window.location.hash.replace('#','') + '"]').click();
			}

		},

		tabShow:function( currentNav ){

			var tabIndex = currentNav.index(),
				tabID = currentNav.data('id'),
				activeTab = jQuery('#tab-' + tabID),
				tabTitle = jQuery('#tab-title-' + tabID);

			// Update nav
			Theme.tabNavButton.filter('.current-menu-item').removeClass('current-menu-item');

			if ( !currentNav.hasClass('nav-sub-parent') )
				currentNav.addClass('current-menu-item');

			Theme.tabTitleButton.removeClass('active');
			tabTitle.addClass('active');

			// ScrollTo
			var scrollTo = Theme.tabNav.parents('.panel-grid').offset().top;
			if ( scrollTo != Theme.scrollPosition )
				jQuery("html, body").animate({ scrollTop: scrollTo }, 'fast');

			// Show content
			jQuery('.tab:visible').fadeOut(function(){
				activeTab.fadeIn(function(){
					if (document.createEvent) {
						var e = document.createEvent('HTMLEvents');
						e.initEvent('resize', true, false);
						document.body.dispatchEvent(e);
					} else if (document.createEventObject) {
						document.body.fireEvent('onresize');
					}
				});
			});

			// Update location
			history.pushState("", document.title, currentNav.data('title'));
		},

		tabSlideToggle:function(obj){

			// Update tab view
			obj.toggleClass('active');
			obj.next().slideToggle();

			// Update location
			history.pushState("", document.title, obj.data('title') );

		},

		toggleNav:function(){

			Theme.savedScrollPos = Theme.w.scrollTop();
			Theme.body.toggleClass( 'nav-visible' );

			if ( Theme.body.hasClass( 'nav-visible' ) ) {
				jQuery('html,body').scrollTop(0);
			} else {
				jQuery('html,body').scrollTop(Theme.savedScrollPos);
			}

		},

	};

	Theme.init();

});

jQuery(window).load(function(){
	Theme.resize();
});
